





































































































































































import {Vue, Component, Prop} from "vue-property-decorator";
import QuestionTooltip from "@/components/question_components/QuestionTooltip.vue";
import Slider from "@/components/question_components/ImportanceSlider.vue";
import {
    UserInputImportanceType,
    ImportanceQuestionType
} from "@/types/surveyTab.type";

@Component({
    components: {
        QuestionTooltip,
        Slider
    }
})
export default class ImportanceQuestion extends Vue {
    @Prop() value!: UserInputImportanceType;
    @Prop() question!: ImportanceQuestionType;
    @Prop() tabName!: string;
    hover = false;
    commentEditMode = false;

    commentAction() {
        // Add Comment
        if (this.value.comments === null && this.commentEditMode == false) {
            this.value.comments = "";
            this.commentEditMode = true;
        }
        //Delete Comment
        else if (this.commentEditMode && this.value.comments !== null) {
            this.value.comments = null;
            this.commentEditMode = false;
        }
        // Set Edit mode
        else if (!this.commentEditMode && this.value.comments !== null) {
            this.commentEditMode = true;
        }
    }

    freezeComment() {
        if (this.value.comments !== null && this.value.comments !== "") {
            this.commentEditMode = false;
        } else if (this.value.comments == "") {
            this.value.comments = null;
            this.commentEditMode = false;
        }
    }

    resetDefault() {
        this.value.userValue = this.question.default;
    }
    verifyValue() {
        if (this.value.userValue > 5) {
            this.value.userValue = 5;
        }
        if (this.value.userValue < 1) {
            this.value.userValue = 1;
        }
    }
    get commentSet() {
        if (this.value.comments == null) {
            return false;
        } else return true;
    }

    get showBookmarker() {
        if (this.hover || this.value.bookmarked) {
            return true;
        } else return false;
    }
}
